var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"html-editor mb-4"},[_c('div',{staticClass:"html-editor__label"},[_vm._v(_vm._s(_vm.label))]),_c('vue-editor',{attrs:{"value":_vm.value || '',"editor-toolbar":_vm.toolbar},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }